var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.75C0.0390625 12.9375 0.722656 10.418 2.05078 8.19141C3.37891 5.92578 5.17578 4.12891 7.44141 2.80078C9.66797 1.47266 12.1875 0.789063 15 0.75C17.8125 0.789063 20.332 1.47266 22.5586 2.80078C24.8242 4.12891 26.6211 5.92578 27.9492 8.19141C29.2773 10.418 29.9609 12.9375 30 15.75C29.9609 18.5625 29.2773 21.082 27.9492 23.3086C26.6211 25.5742 24.8242 27.3711 22.5586 28.6992C20.332 30.0273 17.8125 30.7109 15 30.75C12.1875 30.7109 9.66797 30.0273 7.44141 28.6992C5.17578 27.3711 3.37891 25.5742 2.05078 23.3086C0.722656 21.082 0.0390625 18.5625 0 15.75ZM21.7969 13.1719C22.1094 12.8203 22.2656 12.4297 22.2656 12C22.2656 11.5703 22.1094 11.1797 21.7969 10.8281C21.4453 10.5156 21.0547 10.3594 20.625 10.3594C20.1953 10.3594 19.8047 10.5156 19.4531 10.8281L13.125 17.1562L10.5469 14.5781C10.1953 14.2656 9.80469 14.1094 9.375 14.1094C8.94531 14.1094 8.55469 14.2656 8.20312 14.5781C7.89062 14.9297 7.73438 15.3203 7.73438 15.75C7.73438 16.1797 7.89062 16.5703 8.20312 16.9219L11.9531 20.6719C12.3047 20.9844 12.6953 21.1406 13.125 21.1406C13.5547 21.1406 13.9453 20.9844 14.2969 20.6719L21.7969 13.1719Z",
    fill: "#0D5EF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1a8f83ca5d9ba17f240085051ae6df98.svg";
export { ForwardRef as ReactComponent };